export default __webpack_public_path__ + "static/media/slider-arrow-left.554637ad.svg";